import vsComponent from '../../functions/vsDialog/index.vue'

export default Vue => {
  Vue.component(vsComponent.name, vsComponent)
}
